export const SET_CONTENT = 'GIFTYA/SET_CONTENT';
export const GET_CONTENT = 'GIFTYA/GET_CONTENT';
export const GET_CONTENT_SUCCESS = 'GIFTYA/GET_CONTENT_SUCCESS';
export const GET_CONTENT_FAILURE = 'GIFTYA/GET_CONTENT_FAILURE';


export const setContent = (data) => ({
    type: SET_CONTENT,
    data
});
export const getContent = (data) => ({
    type: GET_CONTENT,
    data
});
export const getContentSuccess = (data) => ({
    type: GET_CONTENT_SUCCESS,
    data
});
export const getContentFailure = () => ({
    type: GET_CONTENT_FAILURE
});